module.exports = __webpack_public_path__ + "static/media/pamain-extrabold.3933f457.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pamain-extrabold.svg
// module id = ./src/assets/fonts/pamain-extrabold.svg
// module chunks = 6